import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { Status } from '@df/core/status';
import { Basket } from '@df/session/api/basket/basket';
import { UiComponent } from '@df/ui/ui.component';
import { DeliveryPostcodeService } from '../../../common/delivery/delivery-postcode.service';

@Component({
    selector: 'product-add-to-basket',
    templateUrl: 'product-add-to-basket.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductAddToBasketComponent extends UiComponent {
    /**
     * Product
     */
    @Input({
        required: true
    })
    product!: Product<IProductDataV2>;

    /**
     * Requested qty
     */
    @Input({
        required: true
    })
    qty = 1;

    /**
     * Services
     */
    private basket = inject(Basket);
    private deliveryPostcodeService = inject(DeliveryPostcodeService);

    /**
     * Add product do basket for collection
     */
    protected addToCollection(status: Status, branchNumber: number) {
        return this.addToBasket(status, { isCollection: 'true', branchNumber });
    }

    /**
     * Add product do basket for delivery
     */
    protected addToDelivery(status: Status) {
        return this.addToBasket(status, { isCollection: 'false', branchNumber: -1, postcode: this.deliveryPostcodeService.postcode() });
    }

    /**
     * Add to basket shared part
     */
    private addToBasket(status: Status, requestPatch: any) {
        this.basket.add(
            status,
            {
                ...requestPatch,
                id: this.product.id,
                qty: this.qty
            },
            undefined,
            undefined
        );
    }
}
